import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";
import { ContractInputGetAll } from "../page/contract/ContractInterfaces";
import dayjs from "dayjs";
import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

export const useContractActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();

    const { globalData: { user }  } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

    async function getContractList(filters: ContractInputGetAll, customer: string | null) {
        let customerId = customer ? customer : filters.customerId ? filters.customerId : undefined;

        let createdDateFrom: Date = filters.createdDateFrom;
        let createdDateTo: Date  = filters.createdDateTo;
        let lastModifiedDateFrom: Date = filters.lastModifiedDateFrom;
        let lastModifiedDateTo: Date = filters.lastModifiedDateTo;

        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            status: filters.status ? filters.status : undefined,
            id:filters.id ? filters.id : undefined,
            customerId:  customerId,
            subscriptionPlanName:filters.subscriptionPlanName ? filters.subscriptionPlanName: undefined,
            subscriptionPlanCategory:filters.commercialCategory ? filters.commercialCategory : undefined,
            customerName:filters.customerName ? filters.customerName : undefined,
            voucherCode: filters.voucherCode ? filters.voucherCode : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset ? filters.offset : undefined ,
            limit: filters.limit ? filters.limit : undefined,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined,
            createdDateFrom: createdDateFrom ? dayjs(createdDateFrom).toISOString() : null,
            createdDateTo: createdDateTo ?  dayjs(createdDateTo).toISOString() : null,
            lastModifiedDateFrom: lastModifiedDateFrom ? dayjs(lastModifiedDateFrom).toISOString() : null,
            lastModifiedDateTo: lastModifiedDateTo ? dayjs(lastModifiedDateTo).toISOString() : null
        };
        let contractGetAllResponse = await GET("sm/subscription/", true, {
            params,
            paramsSerializer: (params: ContractInputGetAll) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: contractGetAllResponse?.result?.totalElements,
            content: contractGetAllResponse?.result?.content
        };
    }

    async function getContractById(id: string) {
        let data = await GET("sm/subscription/" + id, true);
        return data?.result;
    }

    async function updateContract(payload: any) {

        return await PUT("sm/subscription/", payload, true)
    }

    async function getPaymentsBySubscriptionId(subscriptionId:string){
            const params = {subscriptionId}
            const {result:paymentListResult} = await GET(`sm/payment/`,true, {
            params,
            paramsSerializer: (params: ContractInputGetAll) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})           
        })
        return paymentListResult?.content
        
    }
    async function getBookingDetailsBySubscriptionId(subscriptionNumber : string, currentRate: number){
        let params = {
            currentRate : currentRate
        };
        return await GET(`sm/booking/getBySubscriptionNumber/`+subscriptionNumber, true,{
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
    }

    async function getInvoiceDetailsBySubscriptionId(subscriptionNumber : string, voucherCode: string | undefined, dealer: string | undefined, legalEntity: string | undefined){
        let params = {
            voucherCode: voucherCode,
            dealers: dealer ? [dealer] : [],
            legalEntities:  legalEntity ? [legalEntity] : allLegalEntities
        };
        return await GET(`sm/fnn/getBySubscriptionNumber/`+subscriptionNumber, true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
    }

    async function getPanCard(paymentToolId: string) {
        return await GET(`sm/subscription/panCard/` + paymentToolId, true)
    }
    async function getBillingAddress(bpCode: string){
        return await GET(`sm/customer-base/`+bpCode, true)
    }

    async function downloadInvoice(invoiceId:number){
        return await GET(`sm/fnn/pdf-invoice/${invoiceId}`, false)
    }
    async function getCategoriesBySegmentCode(tenantId?: string) {
        let params = {
            segmentCode: "SUB",//always SUB for subscriptions
            tenantId: tenantId
        }
        let data = await GET("sm/lookup/category-code", false,{params: params});
        return data?.result ? data.result["category-code"] : [];
    }

    async function cancelSubscription(subscriptionId: any | undefined, note: string | undefined){
        return await POST(`sm/subscription/subscriptioncancellation`, {id : subscriptionId, note: note}, false, {})
    }

    return {
        getContractList,
        getContractById,
        updateContract,
        downloadInvoice,
        getPaymentsBySubscriptionId,
        getBookingDetailsBySubscriptionId,
        getInvoiceDetailsBySubscriptionId,
        getPanCard,
        getBillingAddress,
        getCategoriesBySegmentCode,
        cancelSubscription
    };
}